//
/* jslint browser: true */
//@ts-nocheck
import { CssBaseline, ThemeProvider, StyledEngineProvider } from "client/componentLibrary";
import "flexboxgrid";
import React from "react";
import DocumentTitle from "react-document-title";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, useParams } from "react-router";
import EmployeePasswordChange from "./signInUp/rebrandedLogin/EmployeePasswordChange";
import muiTheme from "./signInUp/rebrandedLogin/loginTheme";
import WorkWithUs from "./signInUp/rebrandedLogin/WorkWithUs";
import * as FullStory from "@fullstory/browser";
import WorkplaceLogin from "signInUp/WorkplaceOSLogin/WorkplaceLogin";
import WorkplaceForgetPassword from "signInUp/WorkplaceOSLogin/ForgetPassword";
import WorkplaceResetPassword from "signInUp/WorkplaceOSLogin/WorkplaceResetPassword";
import WorkplaceSetPassword from "signInUp/WorkplaceOSLogin/WorkplaceSetPassword";
import "componentLibrary/theme/RaiseColors.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
if (!window.IN_DEBUG_MODE) {
  FullStory.init({
    orgId: "138TQ",
    devMode: window.IN_STAGING
  });
}
function WorkplaceResetPasswordRoute() {
  var params = useParams();
  return /*#__PURE__*/_jsx(WorkplaceResetPassword, {
    params: params
  });
}
function WorkplaceSetPasswordRoute() {
  var params = useParams();
  return /*#__PURE__*/_jsx(WorkplaceSetPassword, {
    params: params
  });
}

/* Add any new routes here */
export function App() {
  return /*#__PURE__*/_jsxs(Routes, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/login",
      element: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/login/:next",
      element: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/raise_login",
      element: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/raise_login/:next",
      element: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/workplace_login",
      element: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/okta_workplace_login",
      element: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/workwithus",
      element: /*#__PURE__*/_jsx(WorkWithUs, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/loginchangepassword",
      element: /*#__PURE__*/_jsx(EmployeePasswordChange, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/forgot_password",
      element: /*#__PURE__*/_jsx(WorkplaceForgetPassword, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/reset_password/:reset_code/:user_id",
      element: /*#__PURE__*/_jsx(WorkplaceResetPasswordRoute, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/activate/:activation_code/:user_id/:dealroomId/:user_name/:org_id",
      element: /*#__PURE__*/_jsx(WorkplaceSetPasswordRoute, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/activate/:activation_code/:user_id/:user_name/:org_id",
      element: /*#__PURE__*/_jsx(WorkplaceSetPasswordRoute, {})
    })]
  });
}
var container = document.getElementById("reactbody");
if (container) {
  createRoot(container).render(/*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(DocumentTitle, {
      title: "Login",
      children: /*#__PURE__*/_jsx(StyledEngineProvider, {
        injectFirst: true,
        children: /*#__PURE__*/_jsxs(ThemeProvider, {
          theme: muiTheme,
          children: [/*#__PURE__*/_jsx(CssBaseline, {}), /*#__PURE__*/_jsx(BrowserRouter, {
            basename: "",
            children: /*#__PURE__*/_jsx(App, {})
          })]
        })
      })
    })
  }));
}